import { useAddDiscountCode } from '@/hooks/discount-code/useAddDiscountCode';
import { Box, Collapse, Typography, styled } from '@mui/material';
import { DiscountCodeInput } from './DiscountCodeInput';

type AddDiscountCodeProps = {
  showNoCodeText?: boolean;
};

const Wrapper = styled(Box)(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    width: '28.125rem',
  },
}));

const NoCodeText = styled(Typography)(({ theme }) => ({
  color: 'grey',
  fontSize: '0.90rem',
  marginBottom: theme.spacing(2),
  [theme.breakpoints.down('md')]: {
    marginBottom: theme.spacing(48),
  },
}));

export function AddDiscountCode(props: AddDiscountCodeProps) {
  const { showNoCodeText = true } = props;
  const { expanded, toggleExpanded, input } = useAddDiscountCode();

  return (
    <Wrapper>
      <Typography
        variant="body1"
        component="h2"
        fontWeight={600}
        marginBottom={8}
        marginTop={8}
        sx={{ cursor: 'pointer', textDecoration: 'underline' }}
        onClick={toggleExpanded}
        id="have-promo-code" // do not change this id, it is used for tracking purposes.
      >
        I have a discount code
      </Typography>
      <Collapse in={expanded}>
        <DiscountCodeInput {...input} />
      </Collapse>
      {showNoCodeText && <NoCodeText>No code? Proceed to booking</NoCodeText>}
    </Wrapper>
  );
}
